import React, { useState } from "react";
import s from "./pulse.module.css";
import cn from "classnames";
import DialogForm from "./DialogForm";
import { connect } from "react-redux";
import { sendChatRequest, messageChatErase } from "../../redux/Chat_reducer";

const DialogModal = ({ active, setActive, onSubmit }) => {
  return (
    <div
      className={cn(s.dialogModal, { [s.modalActive]: active })}
      onClick={() => setActive(false)}
    >
      <div
        className={cn(s.modal, { [s.active]: active })}
        onClick={(e) => e.stopPropagation()}
      >
        {/*@ts-ignore*/}
        <DialogForm active={active} onSubmit={onSubmit} />
      </div>
    </div>
  );
};

const PulseButton = ({ sendChatRequest, messageChatErase }) => {
  const [active, setActive] = useState(false);

  const setActiveModal = () => {
    setActive(true);
    messageChatErase("");
  };
  return (
    <React.Fragment>
      <span
        onClick={() => setActiveModal()}
        className={cn("pulse", { pulseNone: active })}
      >
        <span className="pulse2">
          <span className="pulse3">
            <svg
              width="34"
              height="30"
              viewBox="0 0 34 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.9361 11.0786L12.9361 4.70333C12.9361 3.04648 14.2792 1.70333 15.9361 1.70333L29.4362 1.70333C31.093 1.70333 32.4362 3.04647 32.4362 4.70333L32.4362 12.0786C32.4362 13.1832 31.5407 14.0786 30.4362 14.0786L29.8114 14.0786L29.8114 18.9534L27.3971 15.0304C27.0331 14.4389 26.3883 14.0786 25.6938 14.0786L15.9361 14.0786C14.2792 14.0786 12.9361 12.7355 12.9361 11.0786Z"
                stroke="#252525"
                strokeWidth="2"
              />
              <path
                d="M1.68642 18.9532L1.68638 11.4534C1.68637 9.79658 3.02952 8.45343 4.68638 8.45343L10.3111 8.45343L10.3111 13.3283C10.3111 14.9852 11.6542 16.3283 13.3111 16.3283L20.8111 16.3283L20.8111 18.9532C20.8111 20.6101 19.468 21.9532 17.8111 21.9532L8.8087 21.9532C8.16882 21.9532 7.56757 22.2594 7.19121 22.7769L4.79024 26.0783L4.79024 21.9532L4.68642 21.9532C3.02958 21.9532 1.68643 20.6101 1.68642 18.9532Z"
                stroke="#252525"
                strokeWidth="2"
              />
            </svg>
          </span>
        </span>
      </span>
      <DialogModal
        active={active}
        setActive={setActive}
        onSubmit={(values) => sendChatRequest(values)}
      />
    </React.Fragment>
  );
};
const mdtp = (dispatch) => ({
  messageChatErase: (p) => dispatch(messageChatErase(p)),
  sendChatRequest: (p) => dispatch(sendChatRequest(p)),
});
export default connect(null, mdtp)(PulseButton);
